












































































import { defineComponent } from '@vue/composition-api';
import {
  ProductCategoryAttribute,
  ProductCategoryAttributeType,
} from '@/models/entities/ProductCategoryAttribute';

interface Props {
  entityAttributes: ProductCategoryAttribute[];
  hideAttributesKeyWords?: string[];
}

const Component = defineComponent({
  name: 'ProductCategoryAttributesSimpleBlock',

  props: {
    entityAttributes: Array,
    hideAttributesKeyWords: Array,
  },

  setup() {
    function changeAttribute(attribute: ProductCategoryAttribute) {
      attribute.hasOverriddenValue = !isQuantityMissed(attribute.value);
    }

    const isQuantityMissed = (value: number | string) =>
      value === 0 || value === '0' || value === '' || value === null || value === undefined;

    return { ProductCategoryAttributeType, changeAttribute, isQuantityMissed };
  },
})
export default Component;
